define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-our-franchise-featured';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseFeaturedHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseFeaturedSectionHeaderId, 'animate__faster animate__fadeIn', 'our-franchise-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseFeaturedSectionInfoId, 'animate__faster animate__fadeIn', 'our-franchise-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseFeaturedNavWrapperId, 'animate__faster animate__zoomIn', 'our-franchise-featured', {});
            };

            view.bind = function () {

            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
